import React from 'react';
import { Route, IndexRoute } from 'react-router';
import Transactions from './trasactions';

export default (
  <Route path="transacoes">
    <IndexRoute component={props => <Transactions {...props} />} />
  </Route>
);
